import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "../../firebase";
import {
  doc,
  getDoc,
  collection,
  addDoc,
  setDoc,
  serverTimestamp,
  onSnapshot,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { FaCoins } from "react-icons/fa";
import qrCode from "../../assets/qrCode.png";
import CreditRequestList from "../transactions/CreditRequestList";
import FscCard from "../fscCard";
import { Modal, Button } from "react-bootstrap";
import AgentBulkOrderRequest from "../orders/AgentBulkOrderRequest";
import BulkOrderRequests from "../orders/BulkOrderRequests";

const AgentDashboard = () => {
  const [agentData, setAgentData] = useState(null);
  const [activeTab, setActiveTab] = useState("credits");
  const [creditRequest, setCreditRequest] = useState({
    credits: 0,
    amount: "",
    paymentType: "cash",
    remarks: "",
    utr: "",
  });
  const [showCreditForm, setShowCreditForm] = useState(false);
  const navigate = useNavigate();
  const [bulkOrderInputs, setBulkOrderInputs] = useState([
    { rationCardNumber: "", name: "" },
  ]);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const docRef = doc(db, "users", user.uid);

        // Real-time listener
        const unsubscribeSnapshot = onSnapshot(docRef, (snapshot) => {
          if (snapshot.exists()) {
            const userData = { ...snapshot.data(), id: snapshot.id };
            setAgentData(userData);

            // Optional: Update localStorage when credits change
            localStorage.setItem("fscCredits", userData.credits);
          }
        });

        // Cleanup snapshot listener on unmount or auth change
        return () => unsubscribeSnapshot();
      } else {
        navigate("/login");
      }
    });

    return () => unsubscribe(); // cleanup auth state listener
  }, [navigate]);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };
  const confirmLogout = () => {
    setShowLogoutModal(true);
  };

  // Helper function to generate order ID
  const generateOrderId = () => {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const yy = String(now.getFullYear()).slice(-2);
    const random = Math.floor(1000 + Math.random() * 9000); // 4-digit random number
    return `${random}${dd}${mm}${yy}`;
  };

  // Inside your bulk order submission function
  const orderId = generateOrderId();
  const docRef = doc(collection(db, "bulkOrders")); // Generates a doc with random ID

  const handleCreditRequest = async () => {
    if (creditRequest.credits <= 0 || !creditRequest.amount) return;
    try {
      await addDoc(collection(db, "creditRequests"), {
        ...creditRequest,
        uid: agentData.uid,
        accountId: agentData.accountId,
        username: agentData.username,
        status: "pending",
        timestamp: serverTimestamp(),
      });

      alert("Credit request sent to admin");
      setCreditRequest({
        credits: 0,
        amount: "",
        paymentType: "cash",
        remarks: "",
        utr: "",
      });
      setShowCreditForm(false); // Hide form after successful submit
    } catch (error) {
      console.error("Error submitting credit request", error);
    }
  };

  if (!agentData) return <div className="container mt-5">Loading...</div>;

  const canAccessFscCard =
    agentData.printStyle === "selfPrinting" && agentData.credits >= 50;

  if (agentData) {
    localStorage.setItem("fscCredits", agentData.credits);
  }

  if (!agentData.accountId) return;

  <div>Loading...</div>;

  return (
    <div className="container mt-4">
      <div className="d-flex flex-row col-md-12 justify-content-between align-items-center">
        <div className="d-flex">
          <h2>Hello, {agentData.username}</h2>
          <h4 className="mt-2 ms-2">(ID: {agentData.accountId})</h4>
        </div>

        <div className="d-flex align-items-end mt-2">
          <h4
            className={
              agentData.credits < 50
                ? "text-danger"
                : agentData.credits <= 100
                ? "text-info"
                : "text-success"
            }
          >
            Available Credits: <FaCoins className="text-warning" />{" "}
            {agentData.credits}
          </h4>
        </div>
      </div>

      <div className="row">
        <div className="col-md-2">
          <div className="list-group mt-4">
            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "fscCard" ? "active" : ""
              }`}
              onClick={() => setActiveTab("fscCard")}
            >
              Download FSC Card
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "bulkOrder"
              }`}
              disabled={
                agentData.printStyle !== "selfPrinting" &&
                agentData.printStyle !== "bulkOrder"
              }
              onClick={() => setActiveTab("bulkOrder")}
            >
              Bulk Order
            </button>
            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "bulkOrderStatus" ? "active" : ""
              }`}
              onClick={() => setActiveTab("bulkOrderStatus")}
            >
              Bulk Order Status
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "credits" && "active"
              }`}
              onClick={() => setActiveTab("credits")}
            >
              Order Credits
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "requests" && "active"
              }`}
              onClick={() => setActiveTab("requests")}
            >
              View Order Requests
            </button>
            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "downloads" && "active"
              }`}
              onClick={() => setActiveTab("downloads")}
            >
              FSC Downloads List
            </button>
            <button
              className="list-group-item list-group-item-action mt-3"
              onClick={confirmLogout}
            >
              Logout
            </button>
          </div>
        </div>

        <div className="col-md-10 ">
          {activeTab === "bulkOrderStatus" && (
            <>
              <h2>Order Status</h2>
              <BulkOrderRequests role="admin" accountId={agentData.accountId} />
            </>
          )}

          {activeTab === "fscCard" ? (
            canAccessFscCard ? (
              <FscCard />
            ) : (
              <>
                <h2 className="text-danger fw-bold align-middle align-middle  w-50">
                  You don't have credit to access this page. Buy credits or
                  recharge your account.
                </h2>
                <button
                  className="btn btn-success"
                  onClick={() => setActiveTab("credits")}
                >
                  Order Credits
                </button>
              </>
            )
          ) : null}

          {activeTab === "credits" && (
            <div className="card p-4">
              <h4
                className={`mt-2 ms-2 ${
                  agentData.credits < 50
                    ? "text-danger"
                    : agentData.credits <= 100
                    ? "text-warning"
                    : "text-success"
                }`}
              >
                Available Credits: <FaCoins className="text-warning" />{" "}
                {agentData.credits}
              </h4>

              <hr />

              {!showCreditForm && (
                <div className="mb-3">
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowCreditForm(true)}
                  >
                    Request Credits
                  </button>
                </div>
              )}

              {showCreditForm && (
                <>
                  <h5 id="request-credits">Request More Credits</h5>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="No. of Credits"
                        value={creditRequest.credits}
                        onChange={(e) =>
                          setCreditRequest({
                            ...creditRequest,
                            credits: parseInt(e.target.value),
                          })
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Paid Amount"
                        value={creditRequest.amount}
                        onChange={(e) =>
                          setCreditRequest({
                            ...creditRequest,
                            amount: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <select
                        className="form-select"
                        value={creditRequest.paymentType}
                        onChange={(e) =>
                          setCreditRequest({
                            ...creditRequest,
                            paymentType: e.target.value,
                          })
                        }
                      >
                        <option value="cash">Cash</option>
                        <option value="phonepe">PhonePe</option>
                        <option value="gpay">GPay</option>
                        <option value="other">Other</option>
                      </select>
                    </div>

                    {(creditRequest.paymentType === "phonepe" ||
                      creditRequest.paymentType === "gpay") && (
                      <>
                        <div className="col-md-4">
                          <img
                            src={qrCode}
                            alt="QR Code"
                            className="img-fluid border p-2"
                          />
                        </div>
                        <div className="col-md-8">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter UTR / Transaction ID"
                            value={creditRequest.utr}
                            onChange={(e) =>
                              setCreditRequest({
                                ...creditRequest,
                                utr: e.target.value,
                              })
                            }
                          />
                        </div>
                      </>
                    )}

                    <div className="col-12">
                      <textarea
                        className="form-control"
                        placeholder="Remarks"
                        value={creditRequest.remarks}
                        onChange={(e) =>
                          setCreditRequest({
                            ...creditRequest,
                            remarks: e.target.value,
                          })
                        }
                      ></textarea>
                    </div>
                    <div className="col-12 d-flex gap-2">
                      <button
                        className="btn btn-success"
                        onClick={handleCreditRequest}
                      >
                        Submit Request
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={() => {
                          setCreditRequest({
                            credits: 0,
                            amount: "",
                            paymentType: "cash",
                            remarks: "",
                            utr: "",
                          });
                          setShowCreditForm(false);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

          {activeTab === "bulkOrder" && <AgentBulkOrderRequest />}

          {activeTab === "requests" && <CreditRequestList />}

          {activeTab === "downloads" && (
            <div className="card p-4">
              <h5>Downloaded Files</h5>

              {agentData.downloads?.length ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead className="table-success">
                      <tr>
                        <th>Card Number</th>
                        <th>Status</th>
                        <th>Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...agentData.downloads]
                        .sort(
                          (a, b) =>
                            new Date(b.downloadedAt) - new Date(a.downloadedAt)
                        )
                        .map((file, i) => (
                          <tr key={i}>
                            <td>{file.cardNo}</td>
                            <td>Success</td>
                            <td>
                              {new Date(file.downloadedAt).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p>No downloads available.</p>
              )}
            </div>
          )}
        </div>
      </div>
      <Modal show={showLogoutModal} onHide={() => setShowLogoutModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLogoutModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleLogout}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AgentDashboard;
